<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add v-if="hasPerm('products.create')" @invoke-method="invokeMethod($event)" action="showTankProduct"></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetTankProducts()"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams" @open="openSearch()">
                                <v-list>
                                    <v-list-tile class="mb-3">
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>
                                    <v-list-tile class="mb-3">
                                        <bc-autocomplete
                                            v-model="filter.company_id"
                                            :label="$t('lang.company')"
                                            :items="company_options"
                                            item-value="company_id"
                                            item-text="company"
                                            prepend-icon="business"
                                            :hide-details="true"
                                            clearable
                                            @click:clear="filterClearInput()"
                                        ></bc-autocomplete>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>
                <bc-circle-loader v-if="loading"></bc-circle-loader>
                <v-card-text v-else :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="productsTableHeader" :items="tank_products" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="showTankProduct(props.item)">
                                <td>{{ props.item.product_name }}</td>
                                <td style="text-align: center">{{ props.item.specific_gravity }}</td>
                                <td style="text-align: center">{{ props.item.total_active_sensors }}</td>
                                <td class="text-center">{{ props.item.company }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="tank_products"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="tank_product_dialog">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ currObjField("product_id") ? $t("lang.edit_tank_product") : $t("lang.add_tank_product") }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            action="closeTankProductDialog"
                            :dialog-status="tank_product_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="tank_products">
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <bc-autocomplete
                                            :focus="
                                                tank_product_dialog &&
                                                (!currObjField('product_id') || (!!currObjField('product_id') && +currObjField('total_active_sensors') == 0))
                                            "
                                            v-model="tank_product.company_id"
                                            :label="`${$t('lang.company')} *`"
                                            :items="customer_options"
                                            item-value="company_id"
                                            item-text="company"
                                            :initial="currObjField('company')"
                                            :counter="showCounter(tank_product.company_id, 'tank_product.company_id')"
                                            :rules="ifValid('tank_product.company_id')"
                                            :append-icon="
                                                !!currObjField('product_id') && +currObjField('total_active_sensors') != 0 ? 'lock' : '$vuetify.icons.dropdown'
                                            "
                                            :readonly="!!currObjField('product_id') && +currObjField('total_active_sensors') != 0"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="tank_product.product_name"
                                            :label="`${$t('lang.product_name')} *`"
                                            :counter="showCounter(tank_product.product_name, 'tank_product.product_name')"
                                            :rules="ifValid('tank_product.product_name')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="tank_product.specific_gravity"
                                            :label="`${$t('lang.specific_gravity')} *`"
                                            :counter="showCounter(tank_product.specific_gravity, 'tank_product.specific_gravity')"
                                            :rules="ifValid('tank_product.specific_gravity')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs6>
                                        <div :style="{ width: '64px', height: '64px', border: '1px solid black', backgroundColor: colorGen }"></div>
                                        <small>{{ colorGenHex }}</small>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-spacer></v-spacer>
                                        <v-btn color="primary" @click="generateProductColor()">Generate color</v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            v-if="hasPerm('products.delete') && currObjField('product_id') && currObjField('total_active_sensors') == 0"
                            color="error"
                            @mouseup.left="$refs.delete_tank_product.openDialog()"
                            >{{ $t("lang.delete") }}</v-btn
                        >
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="closeTankProductDialog()">{{ $t("lang.cancel") }}</v-btn>
                        <v-btn
                            v-if="hasPerm('products.update')"
                            color="success"
                            @mouseup.left="modifyTankProduct(currObjField('product_id') ? 'patch' : 'post', currObjField('product_id'))"
                            >{{ $t("lang.save") }}</v-btn
                        >
                    </v-card-actions>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_tank_product"
                :heading="$t('lang.delete_tank_product')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="modifyTankProduct('delete', currObjField('product_id'))"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import { store } from "Store/store";
import _ from "lodash";

export default {
    data() {
        return {
            customers: null,
            tank_product: {
                company_id: "",
                product_name: "",
                specific_gravity: "1.000",
                color: "FFFFFF",
            },
            current_obj: null,
            filter: {
                search: "",
                company_id: "",
                page_size: 0,
                page_num: 0,
            },
            tank_product_dialog: false,
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "showTankProduct" },
                { title: this.$t("lang.refresh"), action: "dbGetTankProducts" },
            ],
            dbGetTankProducts: _.debounce(this.getTankProducts, 1500, {
                maxWait: 1500,
                leading: true,
                trailing: false,
            }),
            loading: true,
            colorGen: "#FFFFFF",
            colorGenHex: "#FFFFFF",
        };
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.loading = true;
            _.delay(() => {
                let parsedQuery = JSON.parse(JSON.stringify(to.query));
                store
                    .dispatch("fetchTankProducts", {
                        url: "tank_products",
                        method: "get",
                        stateProperty: "tank_products",
                        commit: true,
                        body: parsedQuery,
                    })
                    .then((data) => {
                        if (typeof data !== "undefined" && data.tank_products) {
                            vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                            vm.finishLoader();
                            vm.loading = false;
                        } else {
                            next({ name: "dashboard", replace: true });
                        }
                    });
            }, 500);
        });
    },
    beforeRouteUpdate(to, from, next) {
        this.loading = true;
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        _.delay(() => {
            this.$store
                .dispatch("fetchTankProducts", {
                    url: "tank_products",
                    method: "get",
                    stateProperty: "tank_products",
                    commit: true,
                    body: parsedQuery,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.tank_products) {
                        this.setQuery(parsedQuery, this.filter, this.default_filter);
                        this.finishLoader();
                        this.loading = false;
                        next();
                    } else {
                        next({ name: "dashboard", replace: true });
                    }
                });
        }, 500);
    },
    computed: {
        ...mapState({
            rules_tank_product: (state) => state.validation.rules_tank_product,
            default_filter: (state) => state.tank_products.tank_products_filter,
            page: (state) => state.tank_products.page,
            tank_products: (state) => state.tank_products.tank_products,
            customer_options: (state) => state.customers.customer_options,
            company_options: (state) => state.companies.company_options,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
        currObjField() {
            return (field) => {
                return this.current_obj && field && this.current_obj[field] ? this.current_obj[field] : "";
            };
        },
        productsTableHeader() {
            const headers = [
                {
                    text: this.$t("lang.product_name"),
                    sortable: false,
                    width: "25%",
                },
                {
                    text: this.$t("lang.specific_gravity"),
                    sortable: false,
                    width: "25%",
                    align: "center",
                },
                {
                    text: this.$t("lang.total_sensors"),
                    sortable: false,
                    width: "25%",
                    align: "center",
                },
                {
                    text: this.$t("lang.company"),
                    sortable: false,
                    width: "25%",
                    align: "center",
                },
            ];
            // let check_companies = this.tank_products
            //     ? _.map(this.tank_products, "company_id").filter((v, i, a) => {
            //           return a.indexOf(v) === i;
            //       })
            //     : [];
            // if ((this.current_user && this.current_user.slug != "customer") || (check_companies && check_companies.length > 0)) {
            //     headers.unshift({
            //         text: this.$t("lang.company"),
            //         sortable: false,
            //         width: "25%",
            //     });
            // }
            return headers;
        },
    },
    methods: {
        ...mapActions(["fetchCustomers", "fetchCompanies"]),
        generateProductColor() {
            let h = 360 * Math.random();
            let s = 25 + 70 * Math.random();
            let l = 85 + 10 * Math.random();
            this.colorGen = "hsl(" + h + "," + s + "%," + l + "%)";
            this.colorGenHex = this.hslToHex(h, s, l);
            this.tank_product.color = this.colorGenHex.substring(1);
        },
        hslToHex(h, s, l) {
            l /= 100;
            const a = (s * Math.min(l, 1 - l)) / 100;
            const f = (n) => {
                const k = (n + h / 30) % 12;
                const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
                return Math.round(255 * color)
                    .toString(16)
                    .padStart(2, "0"); // convert to Hex and prefix "0" if needed
            };
            return `#${f(0)}${f(8)}${f(4)}`;
        },
        async openSearch(force = false) {
            if (this.company_options.length == 0 || force == true) await this.fetchCompanies({ body: { options: 1 } });
        },
        closeTankProductDialog() {
            this.tank_product_dialog = false;
            this.$refs.delete_tank_product.close();
            this.$store.commit("validationOff");
            this.$store.commit("toggleModalLoader", false);
        },
        getTankProducts() {
            this.loading = true;
            this.startLoader();
            this.$store
                .dispatch("fetchTankProducts", {
                    url: "tank_products",
                    method: "get",
                    stateProperty: "tank_products",
                    commit: true,
                    body: JSON.parse(JSON.stringify(this.$route.query)),
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.tank_product_dialog = false;
                    this.$store.commit("toggleModalLoader", false);
                    this.$store.commit("validationOff");
                    this.finishLoader(true);
                    this.loading = false;
                });
        },
        modifyTankProduct(method = null, id = null) {
            if (method) {
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (method == "delete" || this.validateForm("tank_products")) {
                        this.$store.commit("toggleModalLoader", true);
                        this.$store
                            .dispatch("fetchTankProducts", {
                                pk: "product_id",
                                id: id,
                                url: `tank_products/${id ? id : ""}`,
                                method: method,
                                stateProperty: "tank_products",
                                mutate: true,
                                body: this.tank_product,
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    this.closeTankProductDialog();
                                } else {
                                    this.$store.commit("toggleModalLoader", false);
                                }
                            });
                    }
                });
            }
        },
        showTankProduct(item = null) {
            this.current_obj = item;

            if (this.$refs.tank_products) item ? this.$refs.tank_products.resetValidation() : this.$refs.tank_products.reset();

            this.$nextTick(() => {
                this.assignObj(this.tank_product, item, this.rules_tank_product);
                if (this.tank_product.color == "FFFFFF") {
                    this.generateProductColor();
                } else {
                    this.colorGen = this.tank_product.color;
                    this.colorGenHex = this.tank_product.color;
                }
                this.tank_product_dialog = true;
            });
        },
    },
    mounted() {
        if (this.customer_options.length == 0) this.fetchCustomers({ body: { options: 1 } });
    },
};
</script>
